import React from 'react';
import { Table as New } from './Table';
import { convertOldTableProps, OldTableProps } from './converter.old';

export type TableProps = OldTableProps;
export const Table = React.forwardRef<HTMLTableElement, TableProps>((props, ref) => (
  <New {...convertOldTableProps(props)} ref={ref} />
));

Table.displayName = 'Table';
